import { render, staticRenderFns } from "./JobSettings.vue?vue&type=template&id=1b27327c&"
import script from "./JobSettings.vue?vue&type=script&lang=js&"
export * from "./JobSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports